import { Component, OnInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { IItem } from '@coreui/angular-pro'
import { GenericResponse, LeadResponse, CifDetails } from 'src/app/interfaces/apiresponses'; 
import { RestService } from 'src/app/services/rest/rest.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-corporate-leads',
  templateUrl: './corporate-leads.component.html',
  styleUrls: ['./corporate-leads.component.scss'],
  providers: [DatePipe]
})
export class CorporateLeadsComponent implements OnInit, AfterContentChecked {
  selectedSearchButton: number = 1
  searchBtnColor = 'secondary'
  searchAllBtnColor = 'secondary'
  selectedItem: any

  columns = [
    {
      key: 'requestedOn',
      label: 'Received On',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'name',
      label: 'Company Name',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'requestedByEmail',
      label: 'Email ID',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'requestedByMobile',
      label: 'Mobile',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'countryOfRegistration',
      label: 'Country',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'tradeLicenseNumber',
      label: 'Trade License',
      filter: true
    },
    {
      key: 'reference',
      label: 'Approve',
      filter: false
    },
    {
      key: 'id',
      label: 'Reject',
      filter: false
    },
  ];

  usersData: IItem[] = []
  selectedItems = [2, 3];

  constructor(private restApi: RestService, private datePipe: DatePipe, private changeDetector: ChangeDetectorRef){

  }

  ngOnInit() {

  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  // Search Form
  searchCompanyName: string = ''
  searchTrandeLicense: string = ''
  cifSearchForm = new FormGroup({
    searchByCompanyControl: new FormControl(this.searchCompanyName, [Validators.required, Validators.minLength(3)]),
    searchByTradeLicenseControl: new FormControl(this.searchTrandeLicense, [Validators.required, Validators.minLength(3)])
  })

  rowSelected(event: any){
  }

  getRoleBadge(item: any) {
    return "danger"
  }

  getLeadDate(item: any){
    return this.datePipe.transform(item.requestedOn,"dd-MM-yyyy")
  }

  getLeads(){
    this.selectedSearchButton = 1
    this.searchBtnColor = 'primary'
    this.searchAllBtnColor = 'secondary'

    if (this.cifSearchForm.controls['searchByCompanyControl'].value != null && this.cifSearchForm.controls['searchByCompanyControl'].value != '')
    {
      this.searchCompanyName = this.cifSearchForm.controls['searchByCompanyControl'].value
      this.restApi.getCompanyLeadsByName(false, this.searchCompanyName).subscribe({
        next: (v: LeadResponse) => {
          if (v.success) {
            this.usersData = v.registrationRequestDetails.map((item, Reference) => {
              const _selected = this.selectedItems.includes(Reference);
              return {
                ...item,
                _selected
              };
            })
          }
        },
        error: (e) => {

        }
      })
    } else {
      if (this.cifSearchForm.controls['searchByTradeLicenseControl'].value != null && this.cifSearchForm.controls['searchByTradeLicenseControl'].value != '')
      {
        this.searchTrandeLicense = this.cifSearchForm.controls['searchByTradeLicenseControl'].value
        this.restApi.getCompanyLeadsByTradeLicense(false, this.searchTrandeLicense).subscribe({
          next: (v: LeadResponse) => {
            if (v.success) {
              this.usersData = v.registrationRequestDetails.map((item, Reference) => {
                const _selected = this.selectedItems.includes(Reference);
                return {
                  ...item,
                  _selected
                };
              })
            }
          },
          error: (e) => {

          }
        })
      }
    }
  }


  getAllLeads(){
    this.selectedSearchButton = 2
    this.searchBtnColor = 'secondary'
    this.searchAllBtnColor = 'primary'
    this.cifSearchForm.controls['searchByTradeLicenseControl'].setValue('')
    this.cifSearchForm.controls['searchByCompanyControl'].setValue('')

    this.restApi.getCompanyLeadsByName(true, '').subscribe({
      next: (v: LeadResponse) => {
        if (v.success) {
          this.usersData = v.registrationRequestDetails.map((item, Reference) => {
            const _selected = this.selectedItems.includes(Reference);
            return {
              ...item,
              _selected
            };
          })
        }
      },
      error: (e) => {
        this.showAlertBox('Sorry', 'Something went wrong. Please try after some time or contact the technical team')
      }
    })
  }

  onCompanyNameChange(){
    this.cifSearchForm.controls['searchByTradeLicenseControl'].setValue('')
  }

  onTradeLicenseChange(){
    this.cifSearchForm.controls['searchByCompanyControl'].setValue('')
  }

  approveOrRejectLead(Approve: boolean) {
    if (!Approve){
      if (!this.bValidReason){
        return
      }

      this.closeReasonModal()
    }

    this.restApi.approveOrRejectLead(
      this.selectedItem.reference, 
      Approve, 
      this.reasonControl?.value == null?'':this.reasonControl?.value, 
      this.CIFControl?.value == null?'':this.CIFControl?.value).subscribe({
        next: (v: GenericResponse) => {
          //console.log(v)
          if (v.success) {
            if (this.selectedSearchButton == 1)
              this.getLeads()
            else
              this.getAllLeads()
          } else {
            this.showAlertBox('Sorry', 'Something went wrong. Please try after some time or contact the technical team')
          }
        },
        error: (e) => {
          this.showAlertBox('Sorry', 'Something went wrong. Please try after some time or contact the technical team')
        }
    })
  }

  getCifDetails() {
    this.ifCIFValid()

    if (this.bValidCIF) {
      if (this.CIFControl?.value != null || this.CIFControl?.value != undefined) {
        this.restApi.getCifDetails({cif:this.CIFControl?.value}).subscribe({
          next: (v: CifDetails) => {
            if (v.success)
            {
              if (v.customerDetailsRes.responseCode === "000")
              {
                if (v.customerDetailsRes.ciftype === "COMPANY")
                {
                  // Approve the Lead
                  this.approveOrRejectLead(true)
                  this.closeCIFModal()
                }
                else
                {
                  this.bValidCIF = false
                  this.CIFError = 'This is not a COMPANY CIF'
                }
              }
            }
            else
            {
              if (v.customerDetailsRes.responseCode === "0025")
              {
                this.bValidCIF = false
                this.CIFError = 'Not a valid CIF'
              }
              else 
              {
                this.bValidCIF = false
                this.CIFError = 'There was a technical issue'
              }
            }
            
          },
          error: (e) => {
            this.bValidCIF = false
            this.CIFError = 'There was a technical issue'
          },
        })
      }
    }
  }

  // Reject Form
  bShowReason = false
  bUndefined!:boolean
  bValidReason!: boolean
  rejectionReason: string = ''
  rejectionForm = new FormGroup({
    reasonControl: new FormControl(this.rejectionReason, [Validators.required, Validators.minLength(5)])
  })

  get reasonControl() { return this.rejectionForm.get('reasonControl') }

  ifReasonValid(){
    if (this.reasonControl?.invalid && (this.reasonControl?.dirty || this.reasonControl?.touched)){
      this.bValidReason = false
      return 'Enter a valid reason'
    } else {
      if (this.reasonControl?.dirty || this.reasonControl?.touched)
        this.bValidReason = true
      else
        this.bValidReason = this.bUndefined
      return ''
    }
  }

  showReasonModal(item: any){
    this.selectedItem = item

    this.reasonControl?.setValue('')
    this.rejectionReason = ''
    this.bValidReason = this.bUndefined
    this.bShowReason = true
  }

  closeReasonModal(){
    this.bShowReason = false
  }

  // Approve Form
  bShowCIFPopup = false
  bValidCIF!: boolean
  CIFValue: string = ''
  CIFError: string = ''
  CIFForm = new FormGroup({
    CIFControl: new FormControl(this.CIFValue, [Validators.required, Validators.minLength(3)])
  })

  get CIFControl() { return this.CIFForm.get('CIFControl') }

  ifCIFValid(){
    if (this.CIFControl?.invalid && (this.CIFControl?.dirty || this.CIFControl?.touched)){
      this.bValidCIF = false
      this.CIFError = 'Enter a valid CIF'
    } else {
      if (this.CIFControl?.dirty || this.CIFControl?.touched)
        this.bValidCIF = true
      else
        this.bValidCIF = this.bUndefined

      this.CIFError = ''
    }
  }

  showCIFModal(item: any){
    this.selectedItem = item

    this.CIFControl?.setValue('')
    this.CIFValue = ''
    this.bValidCIF = this.bUndefined
    this.bShowCIFPopup = true
  }

  closeCIFModal(){
    this.bShowCIFPopup = false
  }

  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any

  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {})
  {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  onAlertButtonClick(event: any){

  }

  closeAlert(event: any){
    this.bAlert = event.state
  }

  alertVisibility(event: any) {
    this.bAlert = event.state
  }
}
